var map = {
	"./Brown_Noise.json": 7036,
	"./Forest_Rain_120.json": 3828,
	"./Forest_Rain_150.json": 1357,
	"./Forest_Rain_180.json": 1849,
	"./Human_High.json": 1697,
	"./Human_Low.json": 9941,
	"./Human_Medium.json": 9348,
	"./Industrial_High.json": 4077,
	"./Industrial_Low.json": 3582,
	"./Industrial_Medium.json": 6966,
	"./Nature_High.json": 5104,
	"./Nature_Low.json": 5916,
	"./Nature_Medium.json": 6012,
	"./Pink_Noise.json": 7484,
	"./Silence.json": 4757,
	"./White_Noise.json": 3974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2902;